var _rect, _rect2, _g, _rect3, _rect4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_69388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_69388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.275 24.25L24.75 20.8L23.7 19.75L21.275 22.125L20.3 21.15L19.25 22.225L21.275 24.25ZM10 13H22V11H10V13ZM22 27C20.6167 27 19.4377 26.5127 18.463 25.538C17.4877 24.5627 17 23.3833 17 22C17 20.6167 17.4877 19.4373 18.463 18.462C19.4377 17.4873 20.6167 17 22 17C23.3833 17 24.5627 17.4873 25.538 18.462C26.5127 19.4373 27 20.6167 27 22C27 23.3833 26.5127 24.5627 25.538 25.538C24.5627 26.5127 23.3833 27 22 27ZM7 26V9C7 8.45 7.19567 7.979 7.587 7.587C7.979 7.19567 8.45 7 9 7H23C23.55 7 24.021 7.19567 24.413 7.587C24.8043 7.979 25 8.45 25 9V15.675C24.6833 15.525 24.3583 15.4 24.025 15.3C23.6917 15.2 23.35 15.125 23 15.075V9H9V23.05H15.075C15.1583 23.5667 15.2877 24.0583 15.463 24.525C15.6377 24.9917 15.8667 25.4333 16.15 25.85L16 26L14.5 24.5L13 26L11.5 24.5L10 26L8.5 24.5L7 26ZM10 21H15.075C15.125 20.65 15.2 20.3083 15.3 19.975C15.4 19.6417 15.525 19.3167 15.675 19H10V21ZM10 17H17.1C17.7333 16.3833 18.4707 15.8957 19.312 15.537C20.154 15.179 21.05 15 22 15H10V17Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 6,
    height: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_69388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 8,
    height: 8
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_69388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.575 25L20.3333 22.6667V22H21.5C21.7944 22 22.0487 21.9041 22.2627 21.7123C22.4764 21.5208 22.6056 21.2833 22.65 21H20V20.3333H22.55C22.4556 20.1389 22.3153 19.9791 22.1293 19.854C21.9431 19.7291 21.7333 19.6667 21.5 19.6667H20V19H24V19.6667H22.9167C22.9944 19.7611 23.0639 19.8639 23.125 19.975C23.1861 20.0861 23.2333 20.2056 23.2667 20.3333H24V21H23.325C23.2806 21.4722 23.0861 21.868 22.7417 22.1873C22.3972 22.5069 21.9833 22.6667 21.5 22.6667H21.2583L23.5 25H22.575Z",
    fill: "#04B7B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBill);
export default __webpack_public_path__ + "static/media/CreateBill.41052b4c2e2fa71367fe8673d6e4a5e7.svg";
export { ForwardRef as ReactComponent };